import React from "react";

import DebounceInput from "react-debounce-input";

const TextInputField = ({ textValue, onUpdateText }) => {
  const checkForDefaultText = (e) => {
    if (e.target.value === "New Text Field") {
      onUpdateText("");
    }
  };

  const handleUpdateText = (event) => {
    onUpdateText(event.target.value);
  };

  return (
    <DebounceInput
      className="input input--text"
      type="text"
      value={textValue}
      debounceTimeout={500}
      onChange={handleUpdateText}
      onClick={checkForDefaultText}
    />
  );
};

export default TextInputField;
